export function calculatePaginationPages(currentPage: number, lastPage: number, pages: number, pagesIntervalSize: number): number[] {
    var startPage = 1;
    var endPage = pages > pagesIntervalSize ? pagesIntervalSize : pages;

    if (currentPage >= pagesIntervalSize) {
        const multiple = Math.floor((currentPage - 1) / pagesIntervalSize);
        startPage = multiple * pagesIntervalSize + 1;
        endPage = startPage + pagesIntervalSize - 1;

        if (endPage > lastPage) {
            endPage = lastPage;
            startPage = Math.max(1, endPage - pagesIntervalSize + 1);
        }
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
}